module.exports = __webpack_public_path__ + "assets/img/32_618_big.f86e5152.jpg";